/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AssessmentComplianceResponse {
    getFixupPrototypeFunction() { return AssessmentComplianceResponse.fixupPrototype; }

    static newInstance(model: Partial<AssessmentComplianceResponse>): AssessmentComplianceResponse {
        let obj = Object.assign(new AssessmentComplianceResponse(), model);
        AssessmentComplianceResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AssessmentComplianceResponse>): AssessmentComplianceResponse {
        if (!model) return null;
        return AssessmentComplianceResponse.newInstance(<AssessmentComplianceResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AssessmentComplianceResponse) {
        if (!obj) return;

        models.AssessmentComplianceResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AssessmentComplianceResponse): boolean {
        Object.setPrototypeOf(obj, AssessmentComplianceResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Configuration Status
     */
    configuration_status: string;

    /**
     * Summary of validation result
     */
    summary: any;

}
